"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringDataPoint = void 0;
const utils_1 = require("ethers/lib/utils");
const DataPoint_1 = require("./DataPoint");
class StringDataPoint extends DataPoint_1.DataPoint {
    constructor(stringDataPointArgs) {
        const valueBytes = (0, utils_1.toUtf8Bytes)(stringDataPointArgs.value);
        super(stringDataPointArgs.dataFeedId, valueBytes);
    }
}
exports.StringDataPoint = StringDataPoint;
//# sourceMappingURL=StringDataPoint.js.map